import { LetterheadConfig, QuoteConfig } from '../types';

/**
 * Aufloesung des globalen Briefkopfs (settings.letterheadConfig) in die
 * QuoteConfig-Form, die alle PDF-Pfade bereits lesen.
 *
 * Blockweise, nicht Feld fuer Feld: existiert letterheadConfig, gelten
 * AUSSCHLIESSLICH seine Felder — auch die leeren. Sonst liesse sich ein
 * Altwert aus quoteConfig nie loeschen (dasselbe Muster wie
 * InvoiceConfig.ownLetterhead). Fehlt das Objekt ganz, bleibt der
 * Altbestand in quoteConfig unveraendert wirksam.
 */

/**
 * Die neun Briefkopf-Felder. Exportiert, weil profileSettings.ts denselben
 * Satz braucht, um den Altbestand aus quoteConfig zu ziehen (Migration) und
 * beim Schreiben zu entfernen — zwei Listen wuerden auseinanderlaufen.
 */
export const LETTERHEAD_FIELDS = [
    'letterheadText',
    'letterheadLeftLine',
    'letterheadLeftLineFontSize',
    'footerFontSize',
    'stationeryPage1',
    'stationeryFollowing',
    'stationeryTopMarginPage1',
    'stationeryTopMarginFollowing',
    'stationeryBottomMargin',
] as const;

/** Pflichtfeld-Standards — dieselben Werte wie AdminGlobalSettings. */
const QUOTE_CONFIG_BASE: QuoteConfig = {
    followUpDays: 14,
    defaultValidityDays: 30,
    defaultTaxRate: 19,
};

export const applyLetterheadConfig = (
    quoteConfig: QuoteConfig | undefined,
    letterhead: LetterheadConfig | undefined,
): QuoteConfig | undefined => {
    if (!letterhead) return quoteConfig;
    const result: QuoteConfig = { ...QUOTE_CONFIG_BASE, ...(quoteConfig || {}) };
    for (const field of LETTERHEAD_FIELDS) {
        // Auch undefined wird uebernommen (loeschen), deshalb delete statt
        // Spread: ein undefined-Schluessel bliebe sonst als Karteileiche.
        delete result[field];
        if (letterhead[field] !== undefined) {
            (result as LetterheadConfig)[field] = letterhead[field] as never;
        }
    }
    return result;
};

/**
 * Briefkopf-Felder aus dem Altbestand ziehen — Vorbelegung der neuen
 * globalen Karte beim ersten Oeffnen, solange settings.letterheadConfig
 * noch nicht existiert.
 */
export const extractLetterheadConfig = (
    quoteConfig: QuoteConfig | undefined,
): LetterheadConfig => {
    const result: LetterheadConfig = {};
    if (!quoteConfig) return result;
    for (const field of LETTERHEAD_FIELDS) {
        if (quoteConfig[field] !== undefined) {
            result[field] = quoteConfig[field] as never;
        }
    }
    return result;
};
